import type {DeferredImageUploadData, ImageData, VideoData} from '@Libraries/add-media-library';
import {ElementDataType, isDeferredImageUploadData} from '@Libraries/add-media-library';
import type {CreateDesignFromMediaModalOpts} from '@Components/design-selector/design-selector.types';

export type MediaItemForPosterCreation = ImageData | VideoData | DeferredImageUploadData;

type SequentialVideoDesignOpts = Pick<CreateDesignFromMediaModalOpts, 'allowMultipagePosterCreation' | 'createSequentialDesignForVideoSelections'>;

const MIN_ITEMS_FOR_SEQUENTIAL_VIDEO_DESIGN = 2;

/**
 * A multi-selection that contains a video is better served by one page whose background row plays
 * the media in order than by one page per item. Deferred uploads have no hashed filename yet, so a
 * batch carrying one falls back to the multipage flow the editor already knows how to finish.
 */
export const shouldCreateSequentialVideoDesign = (items: MediaItemForPosterCreation[], opts: SequentialVideoDesignOpts): boolean => {
  if (!opts.allowMultipagePosterCreation || !opts.createSequentialDesignForVideoSelections) {
    return false;
  }
  if (items.length < MIN_ITEMS_FOR_SEQUENTIAL_VIDEO_DESIGN || items.some(isDeferredImageUploadData)) {
    return false;
  }
  return items.some((item) => item.type === ElementDataType.VIDEO);
};
